import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import useNavigateTo from "../../hooks/useNavigateTo";
import { InboundDeliveryAction } from "../../models/autogenerated-deliveryService-gql/graphql";
import "./DeliveryCtaSection.scss";

export const allCtaActions = [
  InboundDeliveryAction.CanBookTimeSlot,
  InboundDeliveryAction.CanConfirmQuantities,
  InboundDeliveryAction.CanConfirmDeliveryDate,
];

interface DeliveryCtaSectionProps {
  deliveryId: string;
  actions: InboundDeliveryAction[];
}

const DeliveryCtaSection = (props: DeliveryCtaSectionProps) => {
  const { t } = useTranslation();
  const {
    navigateToConfirmQuantities,
    navigateToConfirmDate,
    navigateToBookTimeSlot,
  } = useNavigateTo();
  const { actions, deliveryId } = props;

  const ctaActions = actions.filter((action) => {
    return allCtaActions.includes(action);
  });

  const renderCtaButtons = (action: InboundDeliveryAction, index: number) => {
    let title = "";
    let onClick = () => {};

    switch (action) {
      case InboundDeliveryAction.CanBookTimeSlot:
        title = t("bookTimeslot");
        onClick = () => navigateToBookTimeSlot(deliveryId);
        break;
      case InboundDeliveryAction.CanConfirmQuantities:
        title = t("confirmQuantities");
        onClick = () => navigateToConfirmQuantities(deliveryId);
        break;
      case InboundDeliveryAction.CanConfirmDeliveryDate:
        title = t("confirmDeliveryDate");
        onClick = () => navigateToConfirmDate(deliveryId);
        break;
    }

    return (
      <div key={index} className="page-content-row">
        <Button variant="outlined" onClick={onClick}>
          {">> " + title + " <<"}
        </Button>
      </div>
    );
  };

  if (ctaActions.length === 0) return null;

  return (
    <div data-testid="ctaSection">
      <div className="page-content cta-section">
        {ctaActions.map((action, index) => {
          return renderCtaButtons(action, index);
        })}
      </div>
      <div className="page-content-divider" />
    </div>
  );
};
export default DeliveryCtaSection;
